import styled from 'styled-components';
import { colorScheme, colors, fonts } from 'styles';

export const Container = styled.div`
  position: relative;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 32px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h2`
  font-family: ${fonts.OpenSans};
  font-size: 24px;
  font-weight: 600;
  color: ${colorScheme.text};
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-family: ${fonts.OpenSans};
  font-size: 14px;
  color: ${colors.gray3};
  margin-bottom: 24px;
  line-height: 1.5;
`;

export const ButtonsArea = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  font-family: ${fonts.OpenSans};
  font-size: 14px;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.variant === 'primary' ? `
    background-color: ${colorScheme.primary};
    color: #ffffff;
    
    &:hover:not(:disabled) {
      background-color: ${colors.deepPurple2};
    }
    
    &:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }
  ` : `
    background-color: transparent;
    color: ${colorScheme.text};
    border: 1px solid #c9c9c9;
    
    &:hover {
      background-color: ${colors.lightGray};
    }
  `}
`;

export const ValidationMessage = styled.div<{ type: 'info' | 'error' | 'loading' }>`
  font-family: ${fonts.OpenSans};
  font-size: 13px;
  padding: 12px;
  border-radius: 4px;
  margin-top: 12px;
  
  ${props => {
    if (props.type === 'error') {
      return `
        background-color: #fee;
        color: #c00;
        border: 1px solid #fcc;
      `;
    }
    if (props.type === 'loading') {
      return `
        background-color: #ffe;
        color: #880;
        border: 1px solid #ffc;
      `;
    }
    return `
      background-color: #e8f4fd;
      color: #1e88e5;
      border: 1px solid #90caf9;
    `;
  }}
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  z-index: 10;
`;

export const LoadingSpinner = styled.div`
  border: 4px solid ${colors.gray2};
  border-top: 4px solid ${colorScheme.primary};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingText = styled.p`
  font-family: ${fonts.OpenSans};
  font-size: 16px;
  font-weight: 600;
  color: ${colorScheme.text};
  margin-top: 16px;
`;

export const LoadingSubText = styled.p`
  font-family: ${fonts.OpenSans};
  font-size: 13px;
  color: ${colors.gray3};
  margin-top: 8px;
`;

